<template>
    <div class="fx-g1 fx-col">
        <div class="data_panel fx fx-wrap">
            <div class="data_item" style="background-image: url(http://assets.atomarrow.net/imgs/home_block_1-min.png)">
                <div class="fx fx-m_between">
                    <span class="font16">教师总数</span>
                    <i class="iconfont icon-jiaoshi"></i>
                </div>
                <div class="fx fx-center" style="font-size: 36px">
                    {{ homeData.staffCount }}
                </div>
                <div class="fx fx-m_end">
                    <span class="pointer" @click="goFunc('school_menu_staff_manage')">进入管理 ></span>
                </div>
            </div>
            <div class="data_item" style="background-image: url(http://assets.atomarrow.net/imgs/home_block_2-min.png)">
                <div class="fx fx-m_between">
                    <span class="font16">学生总数</span>
                    <i class="iconfont icon-jiaoshi"></i>
                </div>
                <div class="fx fx-center" style="font-size: 36px">
                    {{ homeData.studentCount }}
                </div>
                <div class="fx fx-m_end">
                    <span class="pointer" @click="goFunc('school_menu_student_manage')">进入管理 ></span>
                </div>
            </div>
            <div class="data_item" style="background-image: url(http://assets.atomarrow.net/imgs/home_block_3-min.png)">
                <div class="fx fx-m_between">
                    <span class="font16">班级总数</span>
                    <i class="iconfont icon-jiaoshi"></i>
                </div>
                <div class="fx fx-center" style="font-size: 36px">
                    {{ homeData.classCount }}
                </div>
                <div class="fx fx-m_end">
                    <span class="pointer" @click="goFunc('school_menu_class_manage')">进入管理 ></span>
                </div>
            </div>
            <div class="data_item" style="background-image: url(http://assets.atomarrow.net/imgs/home_block_4-min.png)"
                v-if="subInstitutionEnable">
                <div class="fx fx-m_between">
                    <span class="font16">子机构总数</span>
                    <i class="iconfont icon-jiaoshi"></i>
                </div>
                <div class="fx fx-center" style="font-size: 36px">
                    {{ homeData.subInstitutionCount }}
                </div>
                <div class="fx fx-m_end">
                    <span class="pointer" @click="goFunc('school_menu_subinstitution_manage')">进入管理 ></span>
                </div>
            </div>
            <div class="data_item" style="background-image: url(http://assets.atomarrow.net/imgs/home_block_5-min.png)">
                <div class="fx fx-m_between">
                    <span class="font16">课程体系数</span>
                    <i class="iconfont icon-jiaoshi"></i>
                </div>
                <div class="fx fx-center" style="font-size: 36px">
                    {{ homeData.lessonSystemCount }}
                </div>
                <div class="fx fx-m_end">
                    <span class="pointer" @click="goFunc('school_menu_lessonsystem_manage')">进入管理 ></span>
                </div>
            </div>
            <div class="data_item" style="background-image: url(http://assets.atomarrow.net/imgs/home_block_6-min.png)">
                <div class="fx fx-m_between">
                    <span class="font16">用户总数</span>
                    <i class="iconfont icon-jiaoshi"></i>
                </div>
                <div class="fx fx-center" style="font-size: 36px">
                    {{ homeData.userCount }}
                </div>
                <div class="fx fx-m_end">
                    <span class="pointer" @click="goFunc('school_menu_user_manage')">进入管理 ></span>
                </div>
            </div>
        </div>

        <div class="fx fx-m_start fx-c_stretch fx-g1">
            <div class="guide_navs fx-col">
                <div class="panel_title fx fx-c_center">
                    <i class="iconfont icon-bangzhu"></i>
                    <span>如何快速开始使用系统</span>

                </div>
                <div class="fx-g1">
                    <div class="guide_nav fx fx-m_between fx-c_center" :class="{'active': guideIndex==i}"
                        v-for="(item, i) in guides" :key="i" @click="guideIndex=i">
                        <span class="fx fx-c_center">
                            <i class="iconfont icon-xing"></i>
                            <span>{{ item.title }}</span>
                        </span>
                        <i class="iconfont icon-jiantou2" v-if="guideIndex==i"></i>
                    </div>
                </div>

            </div>
            <div class="guide_content fx-col fx-c_stretch fx-g1">
                <div class="panel_title fx fx-c_center">
                    <i class="iconfont icon-buzhou"></i>
                    <span>具体步骤 （{{ guideSteps.length }}）</span>
                </div>
                <div class="fx-g1" style="padding: 0 15px">
                    <div class="guide_step fx fx-m_between fx-c_center" v-for="(item, i) in guideSteps" :key="i">
                        <span class="step_number fx fx-center">{{ i + 1 }}</span>
                        <div class="fx-g1">
                            <span class="step_title">{{ item.title }}</span>
                            <p class="step_content">{{ item.content }}</p>
                        </div>
                        <span v-if="item.page" class="step_opt" @click="goFunc(item.page)">
                            <i class="iconfont icon-bianji"></i>
                            立即编辑
                        </span>
                        <span v-if="item.link" class="step_opt" @click="openPage(item.link)">
                            <i class="iconfont icon-yanjing"></i>
                            立即查看
                        </span>
                    </div>
                </div>
            </div>
            <div class="todo_list fx-col">
                <div class="panel_title fx fx-c_center">
                    <i class="iconfont icon-buzhou"></i>
                    <span>待办事项 </span>
                    <div style="height: 20px;width: 250px;margin-left: 20px">
                        <el-progress :text-inside="true" :stroke-width="20" :percentage="todoDoneRate"></el-progress>
                    </div>
                </div>
                <div class="todo_data fx fx-center">
                    <svg width="160px" height="160px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <!-- Wave -->
                        <path id="border" class="border" style="" fill="#eaf1fa"
                            d="M 80 3 A 49 50 0 1 1 80 157 A 49 50 0 1 1 80 3 "></path>
                        <path id="wave-3" fill="rgba(64, 158, 255, .3)"
                            d="M 20 40 C 70 -10 90 80 140 40 A 73 70 0 1 1 20 40 Z">
                            <animate dur="3s" repeatCount="indefinite" attributeName="d" attributeType="XML" values="M 20 40 C 60 30 110 50 140 40 A 73 70 0 1 1 20 40 Z;
                                            M 20 40 C 70 -10 80 80 140 40 A 73 70 0 1 1 20 40 Z;
                                            M 20 40 C 70 40 80 40 140 40 A 73 70 0 1 1 20 40 Z;"></animate>
                        </path>
                        <path id="wave-2" fill="rgba(64, 158, 255)"
                            d="M 20 40 C 60 30 110 50 140 40 A 73 70 0 1 1 20 40 Z">
                            <animate dur="5s" repeatCount="indefinite" attributeName="d" attributeType="XML" values="M 20 40 C 70 -10 80 80 140 40 A 73 70 0 1 1 20 40 Z;
                                            M 20 40 C 70 40 80 40 140 40 A 73 70 0 1 1 20 40 Z;
                                            M 20 40 C 70 -10 90 80 140 40 A 73 70 0 1 1 20 40 Z;"></animate>
                        </path>

                        <text class="liquidFillGaugeText" text-anchor="middle" font-weight="bold" font-size="50px"
                            transform="translate(80,95)" style="fill: #fff">{{ todoData.doneCount }}
                        </text>
                        <text class="liquidFillGaugeText" text-anchor="middle" font-size="20px"
                            transform="translate(115,90)" style="fill: #fff">项
                        </text>
                        <circle cx="80" cy="80" r="73" stroke-width="5" stroke="white" fill="transparent"></circle>
                        <circle xmlns="http://www.w3.org/2000/svg" r="3" fill="#409EFF">

                            <!-- Define the motion path animation -->
                            <animateMotion dur="8s" repeatCount="indefinite">
                                <mpath xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#border" />
                            </animateMotion>
                        </circle>
                        <!--                        <circle cx="80" cy="80" r="78" stroke-width="1" stroke="#409EFF" fill="none" class="percentage-pie-svg" id="theMotionPath"></circle>-->

                    </svg>
                    <!--                    <div class="done_data fx fx-center">-->
                    <!--                        <span style="font-size: 50px;font-weight: bold">{{todoData.doneCount}}</span>-->
                    <!--                        <span style="font-size: 18px"> 项</span>-->
                    <!--                    </div>-->
                    <div class="fx-col fx-c_start" style="margin-left: 40px">
                        <span>完成 <span class="text_primary font24"
                                style="font-weight: bold">{{ todoData.totalCount }}</span>项</span>
                        <span>还剩 <span class="text_warn font24" style="font-weight: bold">{{
                                todoData.todoList.length
                            }}</span>项需要处理</span>
                    </div>
                </div>
                <div class="fx-g1" style="padding:10px">
                    <el-tabs v-model="todoTab" :stretch="true">
                        <el-tab-pane label="全部事项" name="all" class="fx-col">
                            <template v-if="todoData.todoList.length > 0">
                                <div v-for="(item,i) in todoData.todoList" :key="i"
                                    class="todo_item fx fx-m_between fx-c_center">
                                    <span class="fx fx-c_center">
                                        <i class="iconfont text_warn icon-banji1"></i>
                                        {{ item.title }}
                                    </span>
                                    <span class="todo_btn text_primary pointer" @click="goFunc(item.page)">立即处理</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="todo_item text_success fx fx-c_center">
                                    这里暂时没有需要处理的事项
                                </div>
                            </template>
                        </el-tab-pane>
                        <el-tab-pane label="教务管理" name="teach" class="fx-col">
                            <template v-if="teachTodoList.length > 0">
                                <div v-for="(item,i) in teachTodoList" :key="i"
                                    class="todo_item fx fx-m_between fx-c_center">
                                    <span class="fx fx-c_center">
                                        <i class="iconfont text_warn icon-banji1"></i>
                                        {{ item.title }}
                                    </span>
                                    <span class="todo_btn text_primary pointer" @click="goFunc(item.page)">立即处理</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="todo_item text_success fx fx-c_center">
                                    这里暂时没有需要处理的事项
                                </div>
                            </template>
                        </el-tab-pane>
                        <el-tab-pane label="课程资源" name="lesson" class="fx-col">
                            <template v-if="lessonTodoList.length > 0">
                                <div v-for="(item,i) in lessonTodoList" :key="i"
                                    class="todo_item fx fx-m_between fx-c_center">
                                    <span class="fx fx-c_center">
                                        <i class="iconfont text_warn icon-banji1"></i>
                                        {{ item.title }}
                                    </span>
                                    <span class="todo_btn text_primary pointer" @click="goFunc(item.page)">立即处理</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="todo_item text_success fx fx-c_center">
                                    这里暂时没有需要处理的事项
                                </div>
                            </template>
                        </el-tab-pane>
                        <el-tab-pane label="运营中心" name="operate" class="fx-col">
                            <template v-if="operateTodoList.length > 0">
                                <div v-for="(item,i) in operateTodoList" :key="i"
                                    class="todo_item fx fx-m_between fx-c_center">
                                    <span class="fx fx-c_center">
                                        <i class="iconfont text_warn icon-banji1"></i>
                                        {{ item.title }}
                                    </span>
                                    <span class="todo_btn text_primary pointer" @click="goFunc(item.page)">立即处理</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="todo_item text_success fx fx-c_center">
                                    这里暂时没有需要处理的事项
                                </div>
                            </template>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<style scoped>
    .border {

        stroke: #409EFF;
        stroke-dasharray: 480;
        stroke-dashoffset: 480;
        animation: dash 8s linear infinite;

    }

    @keyframes dash {
        to {
            stroke-dashoffset: 0;
        }
    }

    .todo_item:hover {
        background: #f5f7fa;
    }

    .todo_item {
        height: 48px;
        font-size: 16px;
        cursor: pointer;
        padding: 0 10px;
    }

    .todo_item i.iconfont {
        margin-right: 20px;
        font-size: 20px;
    }

    .done_data {
        width: 160px;
        height: 160px;
        color: white;
        background-image: url(http://assets.atomarrow.net/imgs/home_block_7-min.png);
        background-size: 100% 100%;
    }

    .todo_data {
        height: 190px;
        background: #f5f7fa;
        ;
    }

    .todo_list {
        width: 540px;
        margin-left: 16px;
    }

    .step_opt {
        margin-left: 10px;
        color: var(--primary);
    }

    .step_content {
        color: var(--gray);
        margin-top: 5px;
    }

    .guide_step:hover .step_title,
    .guide_step:hover .step_content,
    .guide_step:hover .step_opt {
        color: white;
    }

    .step_title {
        font-size: 18px;
    }

    .guide_step:hover .step_number {
        background: white;
        color: var(--primary);
    }

    .step_number {
        width: 42px;
        height: 42px;
        margin-right: 20px;
        font-size: 24px;
        font-weight: bold;
        background: var(--primary);
        color: white;
        border-radius: 21px;

    }

    .guide_step * {
        transform: none;
    }

    .guide_step:hover {
        background: var(--primary);
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        /*transform: scale(1.02);*/
    }

    .guide_step {
        background: #f5f7fa;
        padding: 26px;
        border-radius: 6px;
        margin-bottom: 20px;
        cursor: pointer;
        user-select: none;
        transition: transform .3s linear;
    }

    .guide_nav.active i.iconfont,
    .guide_nav:hover i.iconfont {
        color: white;
    }

    .guide_nav i.iconfont {
        color: #c8c600;
        margin-right: 4px;
    }

    .guide_nav.active,
    .guide_nav:hover {
        background: var(--primary);
        color: white;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.19);
    }

    .guide_nav {
        height: 62px;
        font-size: 14px;
        padding: 0 20px 0 26px;
        cursor: pointer;
        user-select: none;
        margin-bottom: 5px;
    }

    .panel_title {
        height: 64px;
        padding-left: 25px;
        font-size: 16px;
    }

    .panel_title i.iconfont {
        color: var(--primary);
        font-size: 24px;
        margin-right: 4px;
    }

    .guide_navs,
    .guide_content,
    .todo_list {
        overflow: auto;
        background: white;
    }

    .guide_navs {
        width: 316px;
        margin-right: 16px;
    }

    .data_panel {
        padding-top: 15px;
        padding-left: 15px;
        background: white;
        margin-bottom: 10px;
    }

    .data_item {
        width: 250px;
        height: 150px;
        margin-right: 20px;
        margin-bottom: 15px;
        color: white;
        border-radius: 6px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 15px 20px;
        cursor: pointer;
        transition: transform .3s;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.28);
    }


    .data_item:hover {
        transform: scale(1.1);
    }
</style>


<script>
    import {
        mapState,
        mapMutations
    } from "vuex";
    import guides from '@/store/guide.json';

    export default {
        components: {
            // HelloWorld
        },
        props: [
            "attr"
        ],
        computed: {
            ...mapState({}),
            guideSteps() {
                return this.guides[this.guideIndex].steps;
            },
            teachTodoList() {
                return this.todoData.todoList.filter(item => item.type == 1)
            },
            lessonTodoList() {
                return this.todoData.todoList.filter(item => item.type == 2)
            },
            operateTodoList() {
                return this.todoData.todoList.filter(item => item.type == 3)
            },
            todoDoneRate() {
                if (this.todoData.totalCount == 0 || isNaN(this.todoData.totalCount) || isNaN(this.todoData
                        .doneCount)) {
                    return 0;
                } else {
                    return Math.ceil(this.todoData.doneCount * 100 / this.todoData.totalCount);
                }
            }
        },
        data() {
            return {
                guides: guides,
                guideIndex: 0,

                homeData: {},
                subInstitutionEnable: false,
                todoTab: "all",
                todoData: {
                    totalCount: "",
                    doneCount: "",
                    todoList: [{
                            type: 1,
                            title: "未设置课程体系",
                            page: "school_menu_lessonsystem_manage"
                        },
                        {
                            type: 1,
                            title: "未开设班级",
                            page: "school_menu_class_manage"
                        },
                        {
                            type: 1,
                            title: "未添加学生",
                            page: "school_menu_student_manage"
                        },
                        {
                            type: 1,
                            title: "未添加教师",
                            page: "school_menu_staff_manage"
                        },
                        {
                            type: 2,
                            title: "未添加课程",
                            page: "school_menu_lessonsystem_manage"
                        },
                        {
                            type: 2,
                            title: "未添加任务",
                            page: "school_menu_lessonsystem_manage"
                        },
                        {
                            type: 3,
                            title: "未设置官网信息",
                            page: "school_menu_officalsite_infoset"
                        },
                        {
                            type: 3,
                            title: "未设置官网页面",
                            page: "school_menu_officalsite_pageset"
                        },
                        {
                            type: 3,
                            title: "未设置编程页面",
                            page: "school_menu_programsite_infoset"
                        },
                        {
                            type: 3,
                            title: "未设置编程页面轮播图",
                            page: "school_menu_programsite_bannerset"
                        },
                    ]
                }
            }

        },


        methods: {
            ...mapMutations([
                "openTab"
            ]),
            goFunc(key) {
                this.openTab({
                    funcKey: key,
                    allowDuplicate: false
                })
            },
            openPage(key) {
                window.openTab(key);
            },
            loadData() {
                this.$ajaxGet("/schoolHomeData", data => {
                    this.homeData = data.result;
                })
            },
            loadTodo() {
                this.$ajaxGet("/schoolHomeTodo", data => {
                    this.todoData = data.result;
                })
            },
            loadCheckSubInstitution() {
                this.$ajaxGet("/schoolCheckSubInstitution", data => {
                    this.subInstitutionEnable = data.result;
                })
            },
            loadCheckFunction() {
                this.$ajaxGet("/checkFunction", data => {
                    if (!data.result.officalsite) {
                        this.guides = this.guides.filter(c => c.title != '如何快速创建出自己的网站')
                    }
                    if (!data.result.programsite) {
                        this.guides = this.guides.filter(c => c.title != '如何创建出编程平台')
                    }
                    if (!data.result.subinstitution) {
                        this.guides = this.guides.filter(c => c.title != '学校如何开设子机构')
                    }
                })
            },
            loadExpireInfo() {
                this.$ajaxGet("/institution/getExpireInfo", data => {
                    const success = data.success || false;
                    if (success) {
                        const obj = data.result;
                        this.expireInfoByDays(obj, 15);
                        this.expireInfoByDays(obj, 7);
                        this.expireInfoByDays(obj, 3);
                    }
                })
            },
            expireInfoByDays(institution, days) {
                // 如果没有到期时间, 则不进行过期检测
                if (!institution.expireDate) {
                    return;
                }
                // 判断是否在指定时间段内
                let expireDate = new Date(institution.expireDate);
                let expireRemindDate = new Date(expireDate.getTime() - days * 24 * 60 * 60 * 1000);
                let now = new Date();
                if (now >= expireRemindDate && now <= expireDate) {
                    const expireObj = JSON.parse(localStorage.getItem("expireInfo-" + institution.id + "-" + days)) || {
                        value: "NOT_KNOWN",
                        expireDate: expireDate,
                    };

                    let showConfirm = false;
                    if (now > expireObj.expireDate) {
                        // 过期了
                        showConfirm = true;
                    } else {
                        // 未过期
                        if (expireObj.value === "ALREADY_KNOWN") {
                            return;
                        } else {
                            showConfirm = true;
                        }
                    }
                    if (showConfirm) {
                        let str = "学校到期时间为:" + institution.expireDate + ", 贵学校" + institution.expireDays +
                            ", 请及时联系客服人员续费";
                        this.$alert(str, "学校临期提醒", {
                            confirmButtonText: '确定',
                            callback: action => {
                                if (action === "confirm") {
                                    localStorage.setItem("expireInfo-" + institution.id + "-" + days, JSON
                                        .stringify({
                                            value: "ALREADY_KNOWN",
                                            expireDate: expireDate,
                                        }));
                                }
                            }
                        });
                    }
                }
            },
        },
        created() {
            this.loadCheckFunction();
            this.loadData();
            this.loadTodo();
            this.loadCheckSubInstitution();
            this.loadExpireInfo();

        },
        mounted() {
            //判断是否是,编程后台通过快捷导航栏的方式跳转进来
            var currentUrl = window.location.pathname;
            var lastSegment = currentUrl.split("/").pop();
            if (lastSegment == 'goToClass') {
                //打开一个新的tab,并跳转到指定页面
                this.openTab({
                    funcKey: "school_menu_doteach_manage",
                    attr: null,
                    title: "上课管理",
                    allowDuplicate: false
                });


            }

        }
    }
</script>
